import moment from 'moment'
import { toast } from 'react-toastify'
import DemoraVolcadora from '../../../models/volcadora/demora_volcadora'
import { TABLA_DEMORA_EN_VOLCADORAS, TABLA_ESTADISTICAS_VOLCADORAS } from '../../../config/tables'
import { COLUMNS_DEMORA_EN_VOLCADORAS, COLUMNS_ESTADISTICAS_VOLCADORAS } from './constantesEstadisticasVolcadoras'
import EstadisticasVolcadora from '../../../models/volcadora/estadisticas_volcadora'
import { getMotivosVolcadora, requestVolcadoraCamiones } from '../../Volcadora/actions'
import { getFormValues, reset } from 'redux-form'
import { FORM_PRODUCTIVIDAD_VOLCADORAS } from '../../../config/forms'
// import DemoraBruto from '../../../models/pesado/demora_bruto'

export function parseData (data) {
  const parsedData = []
  data && data.map((entry) => {
    return parsedData.push({ ...entry, data: entry })
  })
  return parsedData
}

export function parseDataDemoras (data, dataBruto) {
  const parsedData = []
  data && data.map((entry) => {
    // const ref = `${entry.inicioDeDemora}_${entry.volcadoraCamiones}`
    // const demoraEnBruto = dataBruto && dataBruto.filter(db => db.referenciaDemora && (db.referenciaDemora).trim() === ref.trim())
    // const demoraRef = demoraEnBruto && demoraEnBruto[0]
    // const demora = {
    //   claveMotivo: entry.claveMotivoDeDemora,
    //   motivo: entry.motivoDeDemora,
    //   motivoDemoraEnBruto: demoraRef && demoraRef.nombreMotivoDeDemora ? ` : ${demoraRef.nombreMotivoDeDemora}` : null
    // }
    // return parsedData.push({ ...entry, data: entry, demora: demora, demoraEnBruto: demoraEnBruto })
    return parsedData.push({ ...entry, data: entry })
  })
  return parsedData
}

export function obtenerDemorasEnVolcadoras (fechaDesde, fechaHasta, filtroInicial = null) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DEMORA_EN_VOLCADORAS
    })

    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')
    // Promise.all([
    //   DemoraVolcadora.getDemoraVolcadora(fechaD, fechaH),
    //   // DemoraBruto.getDemorasEnBruto(fechaD, fechaH)
    // ])
    //   .then(([d, dBruto]) => {
    DemoraVolcadora.getDemoraVolcadora(fechaD, fechaH).then((d) => {
      // const data = parseDataDemoras(d, dBruto)
      const data = parseDataDemoras(d)
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DEMORA_EN_VOLCADORAS,
          data: data,
          title: 'Demoras en volcadoras',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar: null,
            download: false,
            pagination: false,
            tableBodyMaxHeight: '450px',
            filtroInicial: filtroInicial
          }
        },
        id: TABLA_DEMORA_EN_VOLCADORAS
      })
    })
  }
}

export function getEstadisticasVolcadoras (fechaDesde, fechaHasta) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_ESTADISTICAS_VOLCADORAS
    })
    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')
    EstadisticasVolcadora.getEstadisticasVolcadoras(fechaD, fechaH).then(callback)
    async function callback (d) {
      const data = parseData(d)
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_ESTADISTICAS_VOLCADORAS,
          data: data,
          title: 'Estadísticas de volcadoras',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar: null, download: false, pagination: false, tableBodyMaxHeight: '450px' }
        },
        id: TABLA_ESTADISTICAS_VOLCADORAS
      })
    }
  }
}

export function deleteDemoraEnVolcadora (inicio, volcadora) {
  return (dispatch) => {
    return DemoraVolcadora.deleteDemoraVolcadora(inicio, volcadora)
      .then((result) => {
        if (!result.error) {
          const fecha = moment(inicio).format('YYYY-MM-DD')
          dispatch(obtenerDemorasEnVolcadoras(fecha, fecha))
        } else {
          toast.error('Error al intentar borrar la demora en volcadora')
        }
      })
      .catch((e) => {
        toast.error('Error al intentar borrar la demora en volcadora')
        console.log(e)
      })
  }
}

export function updateDemoraEnVolcadora (inicio, volcadora) {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_PRODUCTIVIDAD_VOLCADORAS)(state)
    console.log('formvalues ', formValues)
    return DemoraVolcadora.updateDemoraEnVolcadora(formValues, inicio, volcadora)
      .then((result) => {
        if (!result.error) {
          const fecha = moment(inicio).format('YYYY-MM-DD')
          dispatch(obtenerDemorasEnVolcadoras(fecha, fecha))
          toast.success('La demora en volcadora fue modificada correctamente')
        } else {
          toast.error('Error al intentar modificar la demora en volcadora')
        }
      })

      .catch((e) => {
        console.log(e)
        toast.error('Error al intentar modificar la demora en volcadora')
      })
  }
}

export function obtenerMotivosDemoraEnVolcadora () {
  return getMotivosVolcadora()
}

export function obtenerVolcadorasCamiones () {
  return requestVolcadoraCamiones()
}

export function submitDemoraEnVolcadora () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_PRODUCTIVIDAD_VOLCADORAS)(state)
    const fechaInicio = formValues.fechaInicioDemorA
    formValues.username = state.auth.username
    return DemoraVolcadora.insertDemoraEnVolcadora(formValues)
      .then((result) => {
        if (!result.error) {
          toast.success('Se agregó correctamente la demora en volcadora')
          dispatch(obtenerDemorasEnVolcadoras(fechaInicio, fechaInicio))
        } else {
          toast.error('Error al intentar agregar la demora en volcadora')
        }
        dispatch(reset(FORM_PRODUCTIVIDAD_VOLCADORAS))
      })
      .catch((e) => {
        console.log(e)
        toast.error('Error al intentar agregar la demora en volcadora')
        dispatch(reset(FORM_PRODUCTIVIDAD_VOLCADORAS))
      })
  }
}
